module.exports = __webpack_public_path__ + "img/home-nav-icon-4.09d84b2e.png";